import { IdentificationType, SelectableIdType } from 'policyholder/domain/policyholder-identification';
import { ProductModule } from 'product-modules/domain/product-module';
import { PolicyholderLookUpFormData } from '../views/unauthenticated-policyholder-lookup';

export const getSelectableIdTypes = (idTypes: IdentificationType[] | undefined): SelectableIdType[] => {
  const idTypeToSelectableIdTypeMap: { [key in IdentificationType]: SelectableIdType | undefined } = {
    [IdentificationType.Id]: SelectableIdType.Id,
    [IdentificationType.Passport]: SelectableIdType.Passport,
    [IdentificationType.Custom]: undefined,
    [IdentificationType.Email]: SelectableIdType.Email,
    [IdentificationType.Cellphone]: SelectableIdType.Cellphone,
    [IdentificationType.Company]: SelectableIdType.Company,
  };

  if (!idTypes) return [];

  const filteredTypes = idTypes
    .filter((idType) => idTypeToSelectableIdTypeMap[idType] !== undefined)
    .map((idType) => idTypeToSelectableIdTypeMap[idType] as SelectableIdType);

  return filteredTypes.length ? filteredTypes : [];
};

export const getIdTypeValue = (params: {
  identificationType: IdentificationType | SelectableIdType | undefined;
  idTypes: SelectableIdType[];
  // prefillValue: IdentificationType | undefined;
}): SelectableIdType | undefined => {
  const { idTypes, identificationType } = params;

  if (idTypes.includes(identificationType as SelectableIdType)) {
    return identificationType as SelectableIdType;
  }

  if (idTypes.length === 1) {
    return idTypes[0];
  }
};

export const getIdType = (params: { formIdType: IdentificationType; productModule: ProductModule }) => {
  const { formIdType, productModule } = params;

  if (productModule.productModuleDefinition?.settings.policyholder.idTypes.length === 1) {
    return productModule.productModuleDefinition?.settings.policyholder.idTypes[0];
  }

  return formIdType;
};

export const getIdTypes = (productModule: ProductModule): SelectableIdType[] => {
  const selectableIdTypes = getSelectableIdTypes(productModule.productModuleDefinition?.settings.policyholder.idTypes);
  return selectableIdTypes;
};

export const isPrefilledFromLookupData = (
  policyholderLookupData: PolicyholderLookUpFormData | undefined,
  identificationType: SelectableIdType,
) => {
  if (!policyholderLookupData) {
    return false;
  }

  const { idType } = policyholderLookupData;

  switch (idType) {
    case SelectableIdType.Id:
      return identificationType === SelectableIdType.Id;
    case SelectableIdType.Passport:
      return identificationType === SelectableIdType.Passport;
    case SelectableIdType.Email:
      return identificationType === SelectableIdType.Email;
    case SelectableIdType.Cellphone:
      return identificationType === SelectableIdType.Cellphone;
  }
};
